import React from "react";
import { Link } from "react-router-dom";

class FooterBottom extends React.Component {
  render() {
    return (
      <div className="mobile-navi-bar">
        <a href="/rent">
        <p className="m-0"><img src="/images/icon-m-rent.svg" alt="" className="mobile-navi-icon img-fluid mx-auto d-block"/></p>
        Rent
        </a>
        <a href="/buy/device">
        <p className="m-0"><img src="/images/icon-m-buy.svg" alt="" className="mobile-navi-icon img-fluid mx-auto d-block"/></p>
        Buy
        </a>
        <a href="/recharge/device">
        <p className="m-0"><img src="/images/icon-m-recharge.svg" alt="" className="mobile-navi-icon img-fluid mx-auto d-block"/></p>
        Recharge
        </a>
        <a href="/activate">
        <p className="m-0"><img src="/images/icon-m-activate.svg" alt="" className="mobile-navi-icon img-fluid mx-auto d-block"/></p>
        Activation
        </a>
        {/*<a href="/get-sim">
        <p className="m-0"><img src="/images/icon-m-sim.svg" alt="" className="mobile-navi-icon img-fluid mx-auto d-block"/></p>
        SIM
        </a>*/}
      </div>
    );
  }
}

export default FooterBottom;



// WEBPACK FOOTER //
// ./src/layout/MobileNavi.js